import { cn } from "@/components/ui/cn";

const sizeMap = {
  sm: "h-4 w-4 border-2",
  md: "h-5 w-5 border-2",
  lg: "h-6 w-6 border-[3px]",
} as const;

export interface SpinnerProps {
  size?: keyof typeof sizeMap;
  className?: string;
  "aria-label"?: string;
}

/** Indeterminate loading indicator. Spins via CSS animation. */
export function Spinner({ size = "md", className, ...rest }: SpinnerProps) {
  return (
    <span
      role="status"
      className={cn(
        "inline-block animate-spin rounded-full border-current border-t-transparent text-accent",
        sizeMap[size],
        className
      )}
      {...rest}
    />
  );
}
